export const LIST_NAME_CONTEXT = {
  COURSE: 'cursos',
  PLANNER: 'planner',
  BOOK: 'caderno',
};
